import client from './client';

// 세금계산서 부분 수금(한 계산서에 수금이 N번 나눠 들어올 수 있다). bito 신설(2026-10-21,
// ksm_backend BillCollectController 포팅) - OrderBillReviewPanel이 계산서별 수금 내역을
// 보여주고, 내역 하나만 콕 집어 취소할 때 이 API를 직접 쓴다.
const baseUrl = '/api/v1/project/orders/bill-collect';

// 세금계산서 1건의 수금 현황 + 내역(취소분 포함).
export const getSummary = (invUuid) => client.get(`${baseUrl}/${invUuid}`);

// 수금 등록(부분수금 1건 추가).
// payload.planUuid를 비우면 자동배분(FIFO+이월), payload.unlinked=true면 계획 없이 등록.
export const addCollect = (invUuid, payload) => client.post(`${baseUrl}/${invUuid}`, payload);

// 미배정 수금을 계획에 수동 연결(또는 재연결). planUuid를 비우면 다시 미배정으로.
export const linkPlan = (collectUuid, planUuid) =>
  client.put(`${baseUrl}/detail/${collectUuid}/link-plan`, { planUuid });

// 수금 내역 수정.
export const updateCollect = (collectUuid, payload) =>
  client.put(`${baseUrl}/detail/${collectUuid}`, payload);

// 수금 내역 1건 취소(삭제 아님, 사유 필수 - 이력으로 남는다).
export const cancelCollectRecord = (collectUuid, reason) =>
  client.delete(`${baseUrl}/detail/${collectUuid}`, { data: { reason } });
